import type { ClientPortalShellSectionV1 } from "@enrein/shared-contracts/client-link";

const STATE_LABEL: Record<ClientPortalShellSectionV1["state"], string> = {
  AVAILABLE: "Available",
  LOCKED: "Locked",
  COMING_SOON: "Coming soon",
};

export function V10SectionProgress({
  sections,
}: {
  readonly sections: readonly ClientPortalShellSectionV1[];
}) {
  if (sections.length === 0) return null;
  return (
    <nav className="v10-cl-section-progress" aria-label="Project progress">
      <p className="v10-cl-section-progress-title">What unlocks next</p>
      <ol className="v10-cl-section-progress-list">
        {sections.map((section) => (
          <li
            key={section.id}
            className={`v10-cl-section-progress-item v10-cl-section-progress-item--${section.state.toLowerCase()}`}
          >
            <span className="v10-cl-section-progress-label">{section.label}</span>
            <span className="v10-cl-section-progress-state">{STATE_LABEL[section.state]}</span>
          </li>
        ))}
      </ol>
    </nav>
  );
}
